/**
 * hafa-cart-share.js
 * Warenkorb speichern & Angebotsfunktion – schodyhafa.pl
 * Kein Inline-JS – alle Konfiguration über data-* am Container.
 */

(function () {
  'use strict';

  const API_BASE = 'https://mailtool.hafa-treppen.de/api/cart_share.php';

  /* ── Utils ─────────────────────────────────────────────────────── */
  function formatMoney(grosze) {
    // PLN: Preis in Groszach (wie Shopify cents)
    return (grosze / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function formatDate(isoStr) {
    if (!isoStr) return '';
    const d = new Date(isoStr);
    return d.toLocaleDateString('pl-PL', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  function showMsg(el, type, text) {
    el.className = 'hafa-cs-msg hafa-cs-msg--' + type;
    el.textContent = text;
    el.style.display = 'block';
  }

  function clearMsg(el) {
    el.className = 'hafa-cs-msg';
    el.textContent = '';
    el.style.display = 'none';
  }

  /* ── Modal: Warenkorb speichern ─────────────────────────────────── */
  function initSaveCartModal() {
    const overlay = document.getElementById('hafa-cs-modal-overlay');
    // 2026-08-13 (Stefan): Modal an <body> verschieben — es wird innerhalb der
    // Cart-Footer-Section gerendert, deren Stacking-Context das z-index:9999
    // neutralisiert (Mitarbeiter-Foto lag über dem Formular und blockierte Klicks).
    if (overlay && overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }

    if (!overlay) return;

    // 2026-08-13: Rabattstufen dynamisch aus dem Mailtool laden (dort verwaltbar).
    // WICHTIG: erst NACH dem overlay-Guard — auf der Oferta-Seite existiert kein
    // Modal; ein Zugriff davor crashte das gesamte Script (Bug 13.08. nachmittags).
    const discountSel = overlay.querySelector('#hafa-cs-discount');
    if (discountSel) {
      fetch(API_BASE + '?action=config')
        .then((r) => r.json())
        .then((cfg) => {
          if (!cfg || !Array.isArray(cfg.discount_tiers) || !cfg.discount_tiers.length) return;
          const first = discountSel.options[0]; // "kein Rabatt"
          discountSel.innerHTML = '';
          discountSel.appendChild(first);
          cfg.discount_tiers.forEach((t) => {
            const o = document.createElement('option');
            o.value = String(t);
            o.textContent = t + '%';
            discountSel.appendChild(o);
          });
        })
        .catch(() => {});
    }

    const openBtn     = document.getElementById('hafa-cs-open-btn');
    const closeBtn    = overlay.querySelector('.hafa-cs-modal__close');
    const form        = overlay.querySelector('#hafa-cs-form');
    const msgEl       = overlay.querySelector('#hafa-cs-msg');
    const resultPanel = overlay.querySelector('#hafa-cs-result');
    const submitBtn   = overlay.querySelector('.hafa-cs-submit');
    const isAD        = overlay.dataset.isAd === 'true';
    const customerId  = overlay.dataset.customerId || '';

    if (!openBtn || !form) return;

    openBtn.addEventListener('click', () => {
      overlay.classList.add('is-open');
      clearMsg(msgEl);
      form.style.display = 'block';
      resultPanel.classList.remove('is-visible');
    });

    closeBtn && closeBtn.addEventListener('click', () => overlay.classList.remove('is-open'));
    overlay.addEventListener('click', (e) => { if (e.target === overlay) overlay.classList.remove('is-open'); });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      clearMsg(msgEl);

      // Consent prüfen (Modus A)
      const consentEl = form.querySelector('#hafa-cs-consent');
      if (consentEl && !consentEl.checked) {
        showMsg(msgEl, 'error', overlay.dataset.i18nConsent || 'Proszę zaakceptować politykę prywatności.');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = overlay.dataset.i18nSaving || 'Zapisywanie...';

      try {
        // 1. Aktuellen Warenkorb laden
        const cartResp = await fetch('/cart.js');
        if (!cartResp.ok) throw new Error('Błąd koszyka');
        const cart = await cartResp.json();

        if (!cart.items || cart.items.length === 0) {
          showMsg(msgEl, 'error', overlay.dataset.i18nEmpty || 'Koszyk jest pusty.');
          return;
        }

        // 2. Body aufbauen
        const mode = isAD ? 'offer' : 'customer';
        const body = {
          mode,
          cart,
          // Speicher-Sprache: steuert Mail-Sprache + Locale-Präfix des Links (2026-08-13)
          lang: overlay.dataset.lang === 'de' ? 'de' : 'pl',
          'hafa-hp': form.querySelector('#hafa-cs-hp')?.value || '',
          customer_email: form.querySelector('#hafa-cs-email')?.value?.trim() || '',
          // Nachricht (optional, beide Modi) — erscheint NUR auf der Angebotsseite,
          // nie im Mailtext (Spam-Schutz bei frei eingebbarer Empfängeradresse).
          note: form.querySelector('#hafa-cs-note')?.value?.trim() || '',
        };

        if (isAD) {
          body.customer_id      = customerId;
          body.customer_name    = form.querySelector('#hafa-cs-cname')?.value?.trim() || '';
          body.discount_percent = parseInt(form.querySelector('#hafa-cs-discount')?.value || '0', 10);
        }

        // 3. API-Aufruf
        const resp = await fetch(API_BASE + '?action=create', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });

        if (resp.status === 429) {
          showMsg(msgEl, 'error', overlay.dataset.i18nRateLimit || 'Zbyt wiele prób. Spróbuj ponownie za godzinę.');
          return;
        }
        if (resp.status === 403) {
          showMsg(msgEl, 'error', overlay.dataset.i18nForbidden || 'Brak uprawnień.');
          return;
        }
        const data = await resp.json();
        if (!resp.ok || data.error) {
          showMsg(msgEl, 'error', overlay.dataset.i18nError || 'Wystąpił błąd. Spróbuj ponownie.');
          return;
        }

        // 4. Ergebnis anzeigen
        form.style.display = 'none';
        showResult(overlay, resultPanel, data, isAD);

      } catch (err) {
        console.error('[hafa-cart-share]', err);
        showMsg(msgEl, 'error', overlay.dataset.i18nError || 'Wystąpił błąd. Spróbuj ponownie.');
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = overlay.dataset.i18nSave || 'Zapisz koszyk';
      }
    });
  }

  function showResult(overlay, panel, data, isAD) {
    panel.classList.add('is-visible');

    // Link
    const linkEl = panel.querySelector('#hafa-cs-link');
    if (linkEl) linkEl.value = data.url || '';

    // Copy-Button
    const copyBtn = panel.querySelector('#hafa-cs-copy-btn');
    if (copyBtn) {
      copyBtn.addEventListener('click', () => {
        navigator.clipboard.writeText(data.url || '').then(() => {
          copyBtn.textContent = overlay.dataset.i18nCopied || 'Skopiowano!';
          setTimeout(() => {
            copyBtn.textContent = overlay.dataset.i18nCopy || 'Kopiuj';
          }, 2000);
        });
      });
    }

    // Kurzcode (nur Modus B) + Mail-Versand (beide Modi)
    const codeDisplay = panel.querySelector('#hafa-cs-shortcode');
    const sendSection = panel.querySelector('#hafa-cs-send-section');
    const sendBtn     = panel.querySelector('#hafa-cs-send-btn');
    const sendMsgEl   = panel.querySelector('#hafa-cs-send-msg');
    const sendEmailEl = panel.querySelector('#hafa-cs-send-email');

    // Versand-Funktion — vom Button UND vom Auto-Send genutzt (2026-08-13, Stefan:
    // vorher hatte Modus A einen funktionslosen Senden-Button + stillen Auto-Send).
    async function doSend(to) {
      if (!to || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(to)) {
        showMsg(sendMsgEl, 'error', overlay.dataset.i18nInvalidEmail || 'Podaj poprawny adres e-mail.');
        return false;
      }
      if (sendBtn) sendBtn.disabled = true;
      try {
        const r  = await fetch(API_BASE + '?action=send', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: data.token, to }),
        });
        const rd = await r.json();
        if (rd.success) {
          showMsg(sendMsgEl, 'success', overlay.dataset.i18nSent || 'E-mail został wysłany.');
          // Klarer Zustand nach Versand: Button wird zu "erneut senden"
          if (sendBtn) sendBtn.textContent = overlay.dataset.i18nResend || sendBtn.textContent;
          return true;
        }
        showMsg(sendMsgEl, 'error', overlay.dataset.i18nMailError || 'Błąd wysyłki e-mail.');
        return false;
      } catch {
        showMsg(sendMsgEl, 'error', overlay.dataset.i18nMailError || 'Błąd wysyłki e-mail.');
        return false;
      } finally {
        if (sendBtn) sendBtn.disabled = false;
      }
    }

    if (sendBtn) {
      sendBtn.addEventListener('click', () => doSend(sendEmailEl?.value?.trim() || ''));
    }

    if (isAD && data.code) {
      if (codeDisplay) codeDisplay.textContent = data.code;
      if (sendSection) sendSection.style.display = 'block';
    } else {
      if (codeDisplay) codeDisplay.style.display = 'none';
      // Modus A: wenn im Formular eine E-Mail angegeben wurde → automatisch senden
      // und das SICHTBAR machen (Erfolgsmeldung + "erneut senden"-Button).
      const emailVal = document.querySelector('#hafa-cs-email')?.value?.trim() || '';
      if (sendSection && emailVal) {
        sendSection.style.display = 'block';
        if (sendEmailEl) sendEmailEl.value = emailVal;
        doSend(emailVal);
      }
    }
  }

  /* ── Oferta-Seite: Restore-Logik ────────────────────────────────── */
  function initOfferPage() {
    const container = document.getElementById('hafa-offer-page');
    if (!container) return;

    const i18n = window.hafaOfferI18n || {};

    // URL-Parameter lesen
    const urlParams = new URLSearchParams(window.location.search);
    const tokenParam = urlParams.get('token') || '';
    const codeParam  = urlParams.get('code')  || '';

    // Code-Eingabe-Formular
    const codeForm = container.querySelector('#hafa-code-form');
    if (codeForm) {
      codeForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const val = codeForm.querySelector('#hafa-code-input')?.value?.trim().toUpperCase();
        if (val) {
          const url = new URL(window.location.href);
          // Format erkennen: beginnt mit HAFA- → code, sonst token
          if (val.startsWith('HAFA-')) {
            url.searchParams.set('code', val);
          } else {
            url.searchParams.set('token', val);
          }
          url.searchParams.delete(val.startsWith('HAFA-') ? 'token' : 'code');
          window.location.href = url.toString();
        }
      });
    }

    // Sprachumschalter: Dawn setzt return_to ohne Query-String — token/code
    // gingen beim Sprachwechsel verloren. Query an alle Localization-Forms anhängen.
    if (window.location.search.length > 1) {
      document.querySelectorAll('form[action*="/localization"] input[name="return_to"]').forEach((inp) => {
        if (inp.value && !inp.value.includes('?')) inp.value = inp.value + window.location.search;
      });
    }

    if (!tokenParam && !codeParam) return;

    loadOffer(container, tokenParam, codeParam, i18n);
  }

  async function loadOffer(container, token, code, i18n) {
    const loadingEl = container.querySelector('#hafa-offer-loading');
    const contentEl = container.querySelector('#hafa-offer-content');
    const errorEl   = container.querySelector('#hafa-offer-error');

    if (loadingEl) loadingEl.style.display = 'block';

    try {
      const params = token ? `token=${encodeURIComponent(token)}` : `code=${encodeURIComponent(code)}`;
      const resp = await fetch(`${API_BASE}?action=get&${params}`);
      const data = await resp.json();

      if (loadingEl) loadingEl.style.display = 'none';

      if (resp.status === 410 || data.error === 'expired') {
        showOfferError(errorEl, i18n.expired || 'Ta oferta wygasła. Skontaktuj się z doradcą HAFA.');
        return;
      }
      if (resp.status === 404 || data.error === 'not_found') {
        showOfferError(errorEl, i18n.notFound || 'Nie znaleziono oferty. Sprawdź poprawność kodu lub linku.');
        return;
      }
      if (!resp.ok || data.error) {
        showOfferError(errorEl, i18n.error || 'Wystąpił błąd. Spróbuj ponownie.');
        return;
      }

      renderOffer(container, contentEl, data, i18n);

    } catch (err) {
      console.error('[hafa-offer]', err);
      if (loadingEl) loadingEl.style.display = 'none';
      showOfferError(errorEl, i18n.error || 'Wystąpił błąd. Spróbuj ponownie.');
    }
  }

  function showOfferError(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.style.display = 'block';
    el.className = 'hafa-cs-msg hafa-cs-msg--error';
  }

  function renderOffer(container, contentEl, data, i18n) {
    if (!contentEl) return;

    const cart     = data.cart || {};
    const items    = cart.items || [];
    const isOffer  = data.mode === 'offer';
    const isFrozen = isOffer && data.total_frozen;
    const expires  = formatDate(data.expires_at);
    const isRedeemed = !!data.redeemed_at;

    // Preis pro Item aus __pplr_addprice (Zepto), Fallback auf price
    function itemPrice(item) {
      const props = item.properties || {};
      const addPrice = parseFloat(props['_pplr_addprice'] || props['__pplr_addprice'] || 0);
      if (addPrice > 0) return Math.round(addPrice * 100);
      return item.price || 0;
    }

    // Total
    let total = 0;
    items.forEach(item => { total += itemPrice(item) * (item.quantity || 1); });
    const displayTotal = isFrozen ? data.total_frozen : total;

    // Items HTML
    let itemsHtml = '';
    items.forEach(item => {
      const price = itemPrice(item);
      const lineTotal = price * (item.quantity || 1);
      const props = item.properties || {};

      // Sichtbare Properties (keine __ oder _ private Keys)
      const visibleProps = Object.entries(props)
        .filter(([k]) => !k.startsWith('_') && !k.startsWith('__'))
        .map(([k, v]) => `${k}: ${v}`)
        .join(' · ');

      itemsHtml += `
        <li class="hafa-offer-item">
          <div class="hafa-offer-item__title">${escHtml(item.title || '')} × ${item.quantity || 1}</div>
          <div class="hafa-offer-item__price">
            <span>${i18n.priceEach || 'Cena jedn.'}: ${formatMoney(price)}</span>
            <span>${formatMoney(lineTotal)}</span>
          </div>
          ${visibleProps ? `<div class="hafa-offer-item__props">${escHtml(visibleProps)}</div>` : ''}
        </li>
      `;
    });

    // Discount badge — fester Betrag schlaegt den Prozentsatz (Mailtool, 28.10.2026).
    // Der Betrag kommt in der Waehrung des gespeicherten Warenkorbs, nicht in EUR.
    const waehrungSymbol = { PLN: 'zł', EUR: '€' }[data.discount_currency] || (data.discount_currency || '');
    let discountBadge = '';
    if (data.discount_amount > 0) {
      const betrag = Number(data.discount_amount).toLocaleString(
        document.documentElement.lang === 'de' ? 'de-DE' : 'pl-PL',
        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
      );
      discountBadge = `<span class="hafa-offer-discount-badge">-${betrag}&nbsp;${waehrungSymbol}</span>`;
    } else if (data.discount_percent > 0) {
      // Prozentsatz ist frei waehlbar (Mailtool, 28.10.2026) — also mit Dezimaltrenner
      // der Oberflaeche ausgeben und unnoetige Nullen weglassen: 5 % statt 5,00 %.
      const pz = Number(data.discount_percent).toLocaleString(
        document.documentElement.lang === 'de' ? 'de-DE' : 'pl-PL',
        { maximumFractionDigits: 2 }
      );
      discountBadge = `<span class="hafa-offer-discount-badge">-${pz}%</span>`;
    }

    // Note
    const noteHtml = data.note
      ? `<div class="hafa-offer-note"><strong>${i18n.noteLabel || 'Notatka doradcy'}:</strong><br>${escHtml(data.note)}</div>`
      : '';

    // Expires
    const expiredHtml = isRedeemed
      ? `<div class="hafa-offer-expires hafa-offer-expired">${i18n.alreadyRedeemed || 'Oferta została już zrealizowana.'}</div>`
      : `<div class="hafa-offer-expires">${i18n.validUntil || 'Ważna do'}: <strong>${expires}</strong></div>`;

    // Header
    const headerTitle = isOffer
      ? (i18n.offerTitle || 'Twoja oferta HAFA') + (data.code ? ` · ${data.code}` : '')
      : (i18n.cartTitle || 'Zapisany koszyk');

    // 2026-08-13 (Stefan): Kurzcode-Suche ausblenden, sobald ein Warenkorb/Angebot
    // geladen ist — das Feld verwirrt Modus-A-Kunden (die haben keinen Code).
    const codeForm = document.getElementById('hafa-code-form');
    if (codeForm) codeForm.style.display = 'none';

    contentEl.innerHTML = `
      <div class="hafa-offer-card">
        <div class="hafa-offer-card__header">
          <h2>${escHtml(headerTitle)}</h2>
          ${data.customer_name ? `<div class="hafa-offer-card__meta">${escHtml(i18n.for || 'Dla')}: ${escHtml(data.customer_name)}</div>` : ''}
        </div>
        <div class="hafa-offer-card__body">
          ${expiredHtml}
          ${noteHtml}
          <ul class="hafa-offer-items">${itemsHtml}</ul>
          <div class="hafa-offer-total">
            <span>${i18n.total || 'Łącznie'} ${discountBadge}</span>
            <span>${formatMoney(displayTotal)}</span>
          </div>
          ${isOffer && !isFrozen ? `<p style="font-size:1.2rem;color:#888;margin-top:6px;">${i18n.priceNote || '* Cena zostanie przeliczona przy finalizacji zamówienia.'}</p>` : ''}
        </div>
      </div>
      <div id="hafa-merge-section"></div>
      <div id="hafa-add-section" style="display:none;">
        <button class="hafa-offer-add-btn" id="hafa-add-to-cart-btn">
          ${i18n.addToCart || 'Dodaj do koszyka'}
        </button>
        <div id="hafa-add-msg" class="hafa-cs-msg" style="display:none;"></div>
      </div>
    `;

    contentEl.style.display = 'block';

    if (isRedeemed) return; // Bereits eingelöst – kein Button

    // Prüfen ob aktueller Warenkorb leer
    fetch('/cart.js').then(r => r.json()).then(currentCart => {
      const hasItems = currentCart.items && currentCart.items.length > 0;
      const mergeSection = document.getElementById('hafa-merge-section');
      const addSection   = document.getElementById('hafa-add-section');

      if (hasItems) {
        mergeSection.innerHTML = `
          <div class="hafa-offer-merge">
            <p>${i18n.mergeQuestion || 'Twój koszyk nie jest pusty. Co chcesz zrobić?'}</p>
            <div class="hafa-offer-merge-btns">
              <button class="hafa-offer-merge-btn hafa-offer-merge-btn--replace" id="hafa-merge-replace">
                ${i18n.replace || 'Zastąp koszyk'}
              </button>
              <button class="hafa-offer-merge-btn hafa-offer-merge-btn--add" id="hafa-merge-add">
                ${i18n.addToExisting || 'Dodaj do istniejącego'}
              </button>
            </div>
          </div>
        `;
        document.getElementById('hafa-merge-replace')?.addEventListener('click', () => {
          mergeSection.innerHTML = '';
          addSection.style.display = 'block';
          addSection.dataset.replace = 'true';
        });
        document.getElementById('hafa-merge-add')?.addEventListener('click', () => {
          mergeSection.innerHTML = '';
          addSection.style.display = 'block';
          addSection.dataset.replace = 'false';
        });
      } else {
        addSection.style.display = 'block';
        addSection.dataset.replace = 'false';
      }
    }).catch(() => {
      const addSection = document.getElementById('hafa-add-section');
      if (addSection) addSection.style.display = 'block';
    });

    // Add-to-Cart Button
    document.getElementById('hafa-add-to-cart-btn')?.addEventListener('click', async function () {
      this.disabled = true;
      this.textContent = i18n.adding || 'Dodawanie...';
      const msgEl = document.getElementById('hafa-add-msg');
      const replace = document.getElementById('hafa-add-section')?.dataset.replace === 'true';

      try {
        // 1. Bei "ersetzen": Warenkorb leeren
        if (replace) {
          await fetch('/cart/clear.js', { method: 'POST' });
        }

        // 2. Modus B mit Rabatt: Discount-Code setzen BEVOR Warenkorb gefüllt wird
        if (data.has_discount && data.discount_code) {
          // Discount via Redirect: /discount/CODE?redirect=... 
          // Wir setzen den Code über die Ajax API stattdessen
          await fetch(`/discount/${encodeURIComponent(data.discount_code)}`, {
            method: 'GET',
            redirect: 'manual',
          }).catch(() => {});
          // Alternative: Shopify JS API für Discount (funktioniert nicht headless)
          // Wir nutzen den redirect-Trick mit einem hidden iframe
          await applyDiscountCode(data.discount_code);
        }

        // 3. Positionen hinzufügen (seriell, um Reihenfolge zu erhalten)
        for (const item of items) {
          const addBody = {
            id: item.variant_id,
            quantity: item.quantity || 1,
          };
          // 2026-08-12: properties nur mitsenden, wenn wirklich vorhanden.
          // PHP encodiert leere Properties als [] (Array) — Shopify /cart/add.js
          // verlangt aber ein Objekt ("expected Array to be a Hash") → Items ohne
          // Properties (z. B. Podestplatte) schlugen beim Restore fehl.
          if (item.properties && !Array.isArray(item.properties)
              && Object.keys(item.properties).length > 0) {
            addBody.properties = item.properties;
          }
          // selling_plan erhalten wenn vorhanden
          if (item.selling_plan_allocation?.selling_plan?.id) {
            addBody.selling_plan = item.selling_plan_allocation.selling_plan.id;
          }

          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(addBody),
          });
          if (!r.ok) {
            const err = await r.json().catch(() => ({}));
            throw new Error(err.description || 'Błąd dodawania produktu');
          }
        }

        // 4. Redeem markieren (best-effort)
        fetch(`${API_BASE}?action=redeem`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: data.token }),
        }).catch(() => {});

        // 5. Weiterleitung zu /cart
        window.location.href = '/cart';

      } catch (err) {
        console.error('[hafa-offer add]', err);
        showMsg(msgEl, 'error', err.message || (i18n.addError || 'Błąd dodawania do koszyka.'));
        this.disabled = false;
        this.textContent = i18n.addToCart || 'Dodaj do koszyka';
      }
    });
  }

  /**
   * Discount-Code serverseitig anwenden.
   * Shopify kennt keinen sauberen AJAX-Weg – wir laden /discount/CODE
   * in einem versteckten <iframe> (same origin OK da schodyhafa.pl).
   * Timeout 3 s, dann weiter (Discount wird im Warenkorb sichtbar).
   */
  function applyDiscountCode(code) {
    return new Promise((resolve) => {
      const iframe = document.createElement('iframe');
      iframe.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;';
      iframe.src = `/discount/${encodeURIComponent(code)}?redirect=/pages/oferta`;
      document.body.appendChild(iframe);
      const timer = setTimeout(() => {
        document.body.removeChild(iframe);
        resolve();
      }, 3000);
      iframe.onload = () => {
        clearTimeout(timer);
        setTimeout(() => {
          document.body.removeChild(iframe);
          resolve();
        }, 300);
      };
    });
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Init ───────────────────────────────────────────────────────── */
  function init() {
    initSaveCartModal();
    initOfferPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
